export const TIERS = [
  { label: "Job minimum", amount: 200 },
  { label: "Half load", amount: 400 },
  { label: "Three quarter load", amount: 600 },
  { label: "Full load", amount: 800 },
];

export const SURCHARGES = [
  { label: "Heavy / construction debris (per ton)", amount: 300 },
  { label: "Stairs / long carry", amount: 50 },
  { label: "Same day rush", amount: 40 },
  { label: "Specialty disposal (freon/tires/paint)", amount: 30 },
];

export const STAGES = [
  "Lead Created",
  "Quote In Progress",
  "Quote Sent",
  "Quote Approved",
  "Quote Denied",
  "Job Scheduled",
  "Job Complete",
  "Payment Completed",
  "Follow Up Later",
];

export const STAGE_META = {
  "Lead Created": { dot: "bg-charcoal/50", ring: "border-charcoal/30" },
  "Quote In Progress": { dot: "bg-sunny", ring: "border-sunny" },
  "Quote Sent": { dot: "bg-teal", ring: "border-teal" },
  "Quote Approved": { dot: "bg-green-500", ring: "border-green-500" },
  "Quote Denied": { dot: "bg-red-500", ring: "border-red-500" },
  "Job Scheduled": { dot: "bg-blue-500", ring: "border-blue-500" },
  "Job Complete": { dot: "bg-purple-500", ring: "border-purple-500" },
  "Payment Completed": { dot: "bg-coral", ring: "border-coral" },
  "Follow Up Later": { dot: "bg-amber-500", ring: "border-amber-500" },
};
